import { render } from "./profileComponent.vue?vue&type=template&id=f19cf1a0&scoped=true"
import script from "./profileComponent.vue?vue&type=script&lang=js"
export * from "./profileComponent.vue?vue&type=script&lang=js"

import "./profileComponent.vue?vue&type=style&index=0&id=f19cf1a0&scoped=true&lang=scss"
import "./profileComponent.vue?vue&type=style&index=1&id=f19cf1a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19cf1a0"]])

export default __exports__